import { API_URL } from '@/config/env';
import { conformanceApi } from '@/lib/api';

import type {
  AlertSubscription,
  CreateAlertSubscriptionRequest,
  NotificationOptions,
} from './alerts.types';

const BASE = `${API_URL}/alert-subscriptions`;
// The notification options live under the sibling `/system` route, not `/orr`.
const SYSTEM_BASE = API_URL.replace(/\/orr\/?$/, '/system');

/**
 * Public endpoint exposing the accepted notification channels and types.
 * Source of truth is data-driven (SystemConfiguration.notifications): there is
 * no hard-coded fallback. Where the endpoint is unavailable the UI degrades to
 * an explicit "channels unavailable" state instead of inventing values.
 */
export const fetchNotificationOptions = () =>
  conformanceApi.get<NotificationOptions>(`${SYSTEM_BASE}/notification`);

export const fetchMyAlertSubscriptions = () =>
  conformanceApi.get<AlertSubscription[]>(`${BASE}/mine`);

// Bulk create. The API accepts a list of subscriptions: existing ones are
// skipped and only the newly created ones are returned (201 Created). A single
// request that already exists yields a 409. Callers that subscribe a single
// application simply pass a one-item list.
export const createOrrScoreDroppedSubscriptions = (
  data: CreateAlertSubscriptionRequest[],
) =>
  conformanceApi.post<AlertSubscription[]>(`${BASE}/orr-score-dropped`, data);

export const updateAlertSubscriptionChannels = (
  id: string,
  alertChannels: string[],
) =>
  conformanceApi.put<AlertSubscription>(`${BASE}/${encodeURIComponent(id)}`, {
    alertChannels,
  });

export const deleteAlertSubscription = (id: string) =>
  conformanceApi.delete<void>(`${BASE}/${encodeURIComponent(id)}`);
